<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Category">
      <div class="row">
        <div class="col-md-6 form-group">
          Name
          <input
            class="form-control"
            type="text"
            v-model="name"
            @focus="nameEmpty = ''"
          />
          <div class="form-group" style="color: red" v-if="nameEmpty">
            {{ nameEmpty }}
          </div>
        </div>
        <div class="col-md-6 form-group">
          Image
          <b-form-file
            v-model="selectedImage"
            id="fileinput"
            class="form-control"
            type="file"
            @focus="selectedFileEmpty = ''"
            @change="imageUpload"
          ></b-form-file>
          <div class="form-group" style="color: red" v-if="selectedFileEmpty">
            {{ selectedFileEmpty }}
          </div>
        </div>
      </div>

      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="addCategory()"
          >Save</b-button
        >
      </div>

      <!-- <div>
        <b-modal id="modal-center" ref="modal1" :hide-header="true" centered title=""> 
           <template #modal-footer>
          <b-button variant="success" v-on:click="ok()"
            >OK</b-button
          >
        </template>
          <p class="my-1">Category added successfully</p>
        </b-modal>
      </div> -->
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  methods: {
    imageUpload(event) {
      this.selectedImage = event.target.files[0];
    },
    async addCategory() {
      if (this.name == "") {
        this.nameEmpty = "Category name is required";
        return;
      }
      if (this.selectedImage == "") {
        this.selectedFileEmpty = "Category image is required";
        return;
      }
      const formdata = new FormData();
      formdata.append("image", this.selectedImage);
      formdata.append("name", this.name);
      await axios
        .post(`${this.$store.getters.baseUrl}/category/store`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$swal("Success", "Category added successfully", "success");
            this.$router.push({name: 'Tables Category'});
            this.selectedFileEmpty = ""
            this.name = "";
            this.selectedImage = "";
            //document.getElementById('fileinput__BV_file_outer_').lastChild.firstChild.textContent = ""
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          if (error.response.data.status == "error") {
            console.log(error);
            this.$swal("Error", error.response.data.message, "error");
          }
        });
    },
  },
  data() {
    return {
      selectedFileEmpty: null,
      nameEmpty: null,
      name: "",
      selectedImage: [],
    };
  },
};
</script>

